import React from 'react';
import { useSearchParams } from 'react-router-dom';

import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import { EmprestimoUniformeLista } from 'Component/EmprestimoUniforme';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useAppSelector } from 'Store';
import { useRecuperarEmprestimosUniformeQuery } from 'View/Service/Default/EmprestimosUniforme';

const Historico = (): React.ReactElement => {
  const [searchParams] = useSearchParams();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const {
    data: { emprestimos, paginacao } = {},
    isFetching,
    isLoading,
  } = useRecuperarEmprestimosUniformeQuery({
    contain: ['Uniformes'],
    page: searchParams.get('pagina') || 1,
    options: { usuario_id: usuario?.id, assinado: 0 },
  });

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Emprestimos de uniforme"
        descricao="Veja todos seus emprestimos de uniforme não assinados."
      />
      <Buscando exibir={isLoading} />
      <SemRegistros carregando={isLoading} registros={emprestimos?.length} />
      <React.Fragment>
        <div className="bg-white shadow-sm rounded">
          {emprestimos?.map((emprestimo) => (
            <EmprestimoUniformeLista
              key={`${emprestimo.id}-${emprestimo.modificado}`}
              dados={emprestimo}
            />
          ))}
        </div>
      </React.Fragment>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Historico;
